export default __webpack_public_path__ + "static/media/logo.64e048a5.png";